import React from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container } from '@mui/material';
import Table from './Table';

const Labs1 = () => {

  return (
  <React.Fragment>
    <Helmet>
      <title>LabAsService</title>
    </Helmet>
    
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth={false}>
        
        <Table />
      </Container>
    </Box>
  </React.Fragment>
 );
}

export default Labs1;